import { Component, OnInit } from '@angular/core';
import { AwardsService } from './awards.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/shared/user/user.service';

@Component({
  selector: 'app-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.scss']
})
export class AwardsComponent implements OnInit {

  awardsData : any[];
  activeCountries : any[] = [];
  regionCodes : string[]= [];

  constructor(
    private awardsService: AwardsService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    this.route.queryParams
    .subscribe(p => {
      if(p.regionCode){
        this.regionCodes=this.regionCodes.concat(p.regionCode);
      }else{
        this.regionCodes=this.regionCodes.concat(this.userService.getRegions());
      }
      this.awardsService.getAwardsHome(this.regionCodes)
      .subscribe(data => {
        this.awardsData=data;
        // if(data && data.awards.length > 0){
        //   this.activeCountries.push(data.awards[0].countryCode);
        // }
      });
    });
  }

  toggleActiveRows(row : any) {
    let index=this.activeCountries.indexOf(row.countryCode);
    if( index > -1 ) {
      this.activeCountries.splice(index,1);
    }else{
      this.activeCountries.push(row.countryCode);
    }
  }

  isActiveRow(row : any){
    return this.activeCountries.indexOf(row.countryCode) !== -1 ;
  }

  isYearGroupEmpty(row : any, yearGroup : any){
    return row.yearGroups[yearGroup] == undefined ;
  }

}
